import { grey } from '@mui/material/colors';
import React from 'react'

export const AnyDocumentOCR = () => {

    const handle = () => {
        window.location.href = "https://master.d82nsv5mlyhd5.amplifyapp.com/";
    };
    return (
        <div >
            <p style={{color: 'grey', fontSize:'24px'}}>Any Document OCR</p>
            <button
                onClick={handle}
                style={{
                    backgroundColor: "#2563eb",        // blue
                    color: "#ffffff",
                    padding: "12px 24px",
                    fontSize: "16px",
                    fontWeight: "600",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    boxShadow: "0 4px 10px rgba(37, 99, 235, 0.3)",
                    transition: "all 0.2s ease",
                }}
                onMouseOver={(e) => {
                    e.target.style.backgroundColor = "#1d4ed8";
                    e.target.style.transform = "translateY(-1px)";
                }}
                onMouseOut={(e) => {
                    e.target.style.backgroundColor = "#2563eb";
                    e.target.style.transform = "translateY(0)";
                }}
            >
                Go to Link
            </button>


        </div>
    )
}
